import React, { useMemo } from "react";
import { Box } from "@mui/material";
import Lottie from "lottie-react";

import forkliftAnim from "Assets/img/animations/forklift.json";
import moneyAnim from "Assets/img/animations/money.json";
import truckAnim from "Assets/img/animations/truck.json";

export type AreaId = "sales" | "operations" | "warehousing";
export interface BusinessStepperProps {
  active: AreaId;
  selected?: AreaId[];
  size?: number;
  gap?: number;
  align?: "start" | "center" | "end";
}

const ICONS: Record<AreaId, any> = { sales: moneyAnim, operations: truckAnim, warehousing: forkliftAnim };
const ORDER: AreaId[] = ["sales", "operations", "warehousing"];

const BusinessStepper: React.FC<BusinessStepperProps> = ({
  active,
  selected,
  size = 100,
  gap = 16,
  align = "end",
}) => {
  const items = useMemo<AreaId[]>(() => {
    const list = (selected?.length ? selected : ORDER) as AreaId[];
    return ORDER.filter((id) => list.includes(id));
  }, [selected]);

  const renderItems = items.includes(active) ? items : [active, ...items];
  const justifyContent = align === "end" ? "flex-end" : align === "center" ? "center" : "flex-start";

  return (
    <Box sx={{ position: "relative", width: "100%", height: size }}>
      <Box sx={{ position: "absolute", top: size / 2, left: 0, right: 0, height: 2, bgcolor: "#0055A4" }} />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent,
          gap: `${gap}px`,
        }}
      >
        {renderItems.map((id) => {
          const isActive = id === active;
          return (
            <Box
              key={id}
              sx={{
                width: size,
                height: size,
                borderRadius: "50%",
                bgcolor: "#FFFFFF",
                border: `2px solid ${isActive ? "#0055A4" : "#D7DFE7"}`,
                boxShadow: isActive ? "0 0 0 1px rgba(0,85,164,0.12)" : "none",
                display: "grid",
                placeItems: "center",
              }}
            >
              <Box
                sx={{
                  width: size * 0.52,
                  height: size * 0.52,
                  filter: isActive ? "none" : "grayscale(1)",
                  opacity: isActive ? 1 : 0.55,
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Lottie
                  animationData={ICONS[id]}
                  loop={isActive}
                  autoplay={isActive}
                  rendererSettings={{
                    className: isActive ? "bs-anim--active" : "bs-anim--inactive",
                    preserveAspectRatio: "xMidYMid meet",
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default BusinessStepper;
